import { render, staticRenderFns } from "./AddEditRequest.vue?vue&type=template&id=61c68a7c&scoped=true"
import script from "./AddEditRequest.vue?vue&type=script&lang=js"
export * from "./AddEditRequest.vue?vue&type=script&lang=js"
import style0 from "./AddEditRequest.vue?vue&type=style&index=0&id=61c68a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c68a7c",
  null
  
)

export default component.exports